module.exports = __webpack_public_path__ + "assets/img/s1_chart-2.82c481fc.png";